var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#top"}},[_c('v-btn',{attrs:{"text":"","block":"","x-large":""}},[_c('h2',{staticClass:"text-center"},[_vm._v(" ☝️ Scroll to top ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }